import { ClaimDetailSchedule } from '@/components/Domains/Claims/Views/ClaimDetailSchedule'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const SearchSchema = z.object({
  selectedMonth: z.string().optional(),
})

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/schedule')({
  component: ClaimDetailSchedule,
  validateSearch: SearchSchema.parse,
})
